import { getFileUrl } from 'api';
import { normalizeFileResponseItems } from 'api/fileResponseCompat';

export const attachmentIds = (value) => String(value === null || value === undefined ? '' : value).split(',').map((id) => id.trim()).filter(Boolean);

// blob URLs belong to a browser session, never to a saved attachment reference.
export const attachmentUrl = (value) => typeof value === 'string' && !/^blob:/i.test(value.trim()) ? value : '';

export const attachmentFiles = (ids, response) => {
  const items = normalizeFileResponseItems(response);
  return attachmentIds(ids).map((id) => {
    const item = items.find((file) => file && String(file.flowId) === id);
    // Keep orphaned references, so opening and saving does not delete their IDs.
    return { id, url: item ? attachmentUrl(item.fullPathUrl || item.fullPath) : '' };
  });
};

export const refreshUploadFiles = async (files = []) => {
  const pending = files.filter((file) => file && file.id && !attachmentUrl(file.url));
  const ids = pending.map((file) => file.id);
  const response = ids.length ? await getFileUrl({ flowIds: ids.join(','), _GRID_TYPE: 'jq' }) : [];
  const refreshed = attachmentFiles(ids.join(','), response);
  return files.map((file) => ({
    ...file,
    url: attachmentUrl(file.url) || (refreshed.find((item) => String(item.id) === String(file.id)) || {}).url || '',
  }));
};
